import gql from "graphql-tag";

export default gql`
  mutation deleteBathCategory($id: String!) {
  	deleteBathCategory(_id: $id) {
  		_id
  	}
  }
`;
